import allfcLogo from "@/assets/logos/allfc.svg"
import dakssaumLogo from "@/assets/logos/dakssaum.svg"
import kbfEmblemLogo from "@/assets/logos/kbf-emblem.svg"
import kbfLogo from "@/assets/logos/kbf.svg"
import kmmafLogo from "@/assets/logos/kmmaf.svg"
import wbcAmateurLogo from "@/assets/logos/wbc-amateur.png"
import wbcLogo from "@/assets/logos/wbc.png"

/** 홈 히어로 아래에 흘려보내는 격투스포츠 단체 로고 */
const MARQUEE_LOGOS = [
  { source: kbfLogo, label: "KBF" },
  { source: kbfEmblemLogo, label: "KBF 엠블럼" },
  { source: wbcLogo, label: "WBC" },
  { source: wbcAmateurLogo, label: "WBC Amateur" },
  { source: kmmafLogo, label: "KMMAF" },
  { source: allfcLogo, label: "ALL FC" },
  { source: dakssaumLogo, label: "닭싸움" },
]

/**
 * 같은 목록을 두 벌 깐다 — 트랙을 절반(`translateX(-50%)`)만 밀면
 * 두 번째 벌의 첫 로고가 첫 번째 벌의 자리에 정확히 겹쳐 이음선이 보이지 않는다.
 * 두 번째 벌은 화면 낭독에서 빼려고 `isDuplicated` 로 표시한다.
 */
function LogoRow({ isDuplicated }: { isDuplicated: boolean }) {
  return (
    <ul
      aria-hidden={isDuplicated || undefined}
      className="flex shrink-0 list-none items-center gap-4 pr-4 sm:gap-8 sm:pr-8"
    >
      {MARQUEE_LOGOS.map((logo) => (
        <li
          key={logo.label}
          className="group flex h-14 w-32 shrink-0 items-center justify-center sm:h-16 sm:w-40"
        >
          {/* 평소에는 회색, 마우스를 올리면 0.7초에 걸쳐 원래 색으로 돌아온다 */}
          <img
            src={logo.source}
            alt={isDuplicated ? "" : logo.label}
            decoding="async"
            className="max-h-full w-auto max-w-full object-contain opacity-60 mix-blend-multiply grayscale transition-[filter,opacity] duration-700 ease-out group-hover:opacity-100 group-hover:grayscale-0"
          />
        </li>
      ))}
    </ul>
  )
}

export default function HomeLogoMarquee() {
  return (
    <div
      role="group"
      aria-label="격투스포츠 단체 로고"
    >
      <p className="app-txt-eyebrow text-app-text-200">PARTNERS</p>

      <div className="mt-5 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex w-max animate-app-marquee motion-reduce:animate-none">
          <LogoRow isDuplicated={false} />
          <LogoRow isDuplicated={true} />
        </div>
      </div>
    </div>
  )
}
